import React from "react";
import { useSelector } from "react-redux";
import { selectInputArguments } from "../../../store/slices/projectSlice";
import Input from "../../nodes/Logic/Inputs/Input";

export default function VisibilityInputs({
  editedVariable,
  setEditedVariable,
}) {
  const inputArguments = useSelector(selectInputArguments);
  const selectedVariable = inputArguments.find(
    (vg) => vg.Field === editedVariable?.VisibilityField
  );

  return (
    <>
      <h5 className="mt-5">Conditional Visibility </h5>
      <div className="text-secondary">
        Show and validate field/tab if specific field matches condition
      </div>
      <div className="mb-3">
        <label className="form-label">Check field</label>
        <Input
          inputType="select"
          isValidNewOption={() => false}
          isClearable
          options={inputArguments
            .filter(
              (ia) =>
                ia.Field &&
                ia.UUID !== editedVariable?.UUID &&
                (ia.Format === "number" ||
                  (ia.Format === "short-text" && ia.IsSelect))
            )
            .map((ia) => ({
              value: ia.Field,
              label: ia.Label,
            }))}
          value={[editedVariable?.VisibilityField ?? ""]}
          onChange={(values) =>
            setEditedVariable({
              ...editedVariable,
              VisibilityField: values[0],
              VisibilityValues: [],
              VisibilityLogical: "",
            })
          }
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Operator</label>
        <Input
          inputType="select"
          isClearable
          isValidNewOption={() => false}
          options={[
            { value: "is", label: "Equals" },
            { value: "is_not", label: "Not equals" },
            ...(selectedVariable?.Format === "number"
              ? [
                  { value: "gte", label: "Greater than" },
                  { value: "lte", label: "Less than" },
                ]
              : []),
          ]}
          value={[editedVariable?.VisibilityLogical ?? ""]}
          onChange={(values) =>
            setEditedVariable({
              ...editedVariable,
              VisibilityLogical: values[0],
            })
          }
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Value</label>
        <Input
          inputType={selectedVariable?.IsSelect ? "select" : undefined}
          isMulti={["is", "is_not"].includes(editedVariable?.VisibilityLogical)}
          isClearable
          options={selectedVariable?.SelectOptions?.map((opt) => ({
            value: opt,
            label: opt,
          }))}
          isValidNewOption={(v) => !selectedVariable?.IsSelect && !!v.trim()}
          value={editedVariable?.VisibilityValues ?? []}
          onChange={(values) =>
            setEditedVariable({
              ...editedVariable,
              VisibilityValues: values,
            })
          }
        />
      </div>
    </>
  );
}
